import {MyCreditsTabsType} from '../MyCreditsPage';

interface IProps {
  selectedTab: MyCreditsTabsType;
  setSelectedTab: (tab: MyCreditsTabsType) => void;
}

const LoanTabSelector = ({selectedTab, setSelectedTab}: IProps) => {
  const tabClass = (tab: MyCreditsTabsType) =>
    `p-2 border-b-2 transition-colors ${
      selectedTab === tab
        ? 'text-farm-shop-500 border-farm-shop-500'
        : 'text-gray-700 border-transparent'
    }`;

  return (
    <div className="flex items-center gap-6 text-md">
      <button
        className={tabClass('current')}
        onClick={() => setSelectedTab('current')}
      >
        اعتبار جاری
      </button>

      <button
        className={tabClass('paid')}
        onClick={() => setSelectedTab('paid')}
      >
        اعتبار تسویه شده
      </button>
    </div>
  );
};

export default LoanTabSelector;
